import { Box, Checkbox, CircularProgress, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import CustomDialogLoaderComponent from "../../../core/components/common/custom-dialog-loader.component"
import CustomDialog from "../../../core/components/ui/CustomDialog"
import { useEID } from "../hooks/useEID"
import { useEffect, useState } from "react"
import QRCode from "react-qr-code";
import EIDQRCodeComponent from "./eID-qrcode-dialog.component"

const ShareEIDDialogComponent = ({open, handleClose}) => {

    const {isLoadingShareEID, sharedEID, errorShareEID, shareEID} = useEID()

    const [fieldsToShare, setFieldsToShare] = useState([]);
    const [openEIDQRCodeDialog, setOpenEIDQRCodeDialog] = useState(false);
    const [sharedEIDQRCodeValue, setSharedEIDQRCodeValue] = useState(null);

    useEffect(() => {
        if (sharedEID) {
            setSharedEIDQRCodeValue(sharedEID.baseURL)
            handleOpenEIDQRCodeDialog(true)
        }
    }, [JSON.stringify(sharedEID)])

    const handleToggle = (value) => () => {
        const currentIndex = fieldsToShare.indexOf(value.field);
        const newFieldsToShare = [...fieldsToShare];

        if (currentIndex === -1) {
            newFieldsToShare.push(value.field);
        } else {
            newFieldsToShare.splice(currentIndex, 1);
        }

        setFieldsToShare(newFieldsToShare);
    };

    const handleShareEID = () => {
        shareEID(fieldsToShare)
    }

    const handleOpenEIDQRCodeDialog = () => {
        setOpenEIDQRCodeDialog(true)
    }

    const handleCloseEIDQRCodeDialog = () => {
        setOpenEIDQRCodeDialog(false)
    }

    const actions = [
        {
            label: "Cancel",
            onClick: (e) => handleClose(),
            variant: "outlined",
            customStyles: {
                opacity: 1, mr: 1
            }
        },
        {
            label: "Share eID",
            onClick: (e) => handleShareEID(),
        }
    ]

    const eIDFields = [
        {
            field: "lastname",
            label: "Lastname"
        },
        {
            field: "firstname",
            label: "Firstname"
        },
        {
            field: "middlename",
            label: "Middlename"
        },
        {
            field: "email",
            label: "Email"
        },
        {
            field: "birthdate",
            label: "Birthdate"
        },
        {
            field: "contact_no",
            label: "Contact Number"
        },
    ]

    return(
        <>
            <CustomDialog
                open={open}
                onClose={handleClose}
                title="Share eID"
                subtitle={"Select the fields you want to share for your eID"}
                hasDividers={true}
                content={
                    <Box>
                        {(isLoadingShareEID) ?
                            <Box sx={{mb: "80px"}}>
                                <CustomDialogLoaderComponent 
                                    icon={<CircularProgress size={40} sx={{color: "#2196f3"}} />} 
                                    message={"Generating QRCode..."}
                                />
                            </Box>
                        : 
                            <>
                                <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                    {eIDFields.map((item, i) => {
                                        return (
                                            <ListItem
                                                key={i}
                                                disablePadding
                                            >
                                                <ListItemButton role={undefined} onClick={handleToggle(item)} dense>
                                                <ListItemIcon>
                                                    <Checkbox
                                                    edge="start"
                                                    checked={fieldsToShare.includes(item.field)}
                                                    tabIndex={-1}
                                                    disableRipple
                                                    />
                                                </ListItemIcon>
                                                <ListItemText id={i} primary={item.label} />
                                                </ListItemButton>
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            </>
                        }
                    </Box>
                }
                actions={actions}
                maxWidth={"sm"}
                customStyles={{}}
            />

            {
                openEIDQRCodeDialog &&
                <EIDQRCodeComponent open={openEIDQRCodeDialog} handleClose={handleCloseEIDQRCodeDialog} qrcode={sharedEIDQRCodeValue} />
            }
        </>
    )
}

export default ShareEIDDialogComponent